import createStyle from "@josephmark/createstyle"
import clsx from "clsx"

import { P2 } from "@/components/TypeRamp"

export const Label = createStyle("label", clsx(P2.classNames, "block font-normal"))

export const InputEl = createStyle(
  "input",
  clsx(
    "text-[1rem] leading-[1.3] lg:text-[0.875rem]",
    "peer block",
    "w-full px-2 py-2.5",
    "rounded-xl bg-white text-black dark:bg-transparent dark:text-white",
    "border",
    "placeholder-slate/60 dark:placeholder-white/60",
    "appearance-none text-left",
    "disabled:border-scorpion disabled:text-scorpion"
  )
)

export const FieldWrapper = createStyle("div")
